import styled from 'styled-components'

export const BuildingPermitsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 100%;
  width: 100%;
  @media (max-width: 768px) {
    padding: 20px;
    gap: 20px;
  }
`

export const PermitsSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

// Filter styles moved to BuildingPermitsFilters.styles.ts

export const FilterDropdownTrigger = styled.button<{ $active?: boolean }>`
  width: 100%;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid ${({ $active }) => ($active ? '#00ade6' : '#e5e5e5')};
  border-radius: 6px;
  font-size: 14px;
  color: #1a1a1a;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  text-align: left;

  &:hover {
    border-color: #999999;
    background-color: #f8f8f8;
  }

  ${({ $active }) =>
    $active &&
    `
    border-color: #00ade6;
    box-shadow: 0 0 0 3px rgba(0, 173, 230, 0.1);
  `}
`

export const FilterDropdownMenu = styled.div<{ $active?: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  visibility: ${({ $active }) => ($active ? 'visible' : 'hidden')};
  transform: translateY(${({ $active }) => ($active ? '0' : '-10px')});
  transition: all 0.2s;
  z-index: 100;
  max-height: 320px;
  overflow-y: auto;

  @media (max-width: 768px) {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0;
    border-radius: 12px 12px 0 0;
    max-height: 70vh;
    transform: translateY(${({ $active }) => ($active ? '0' : '100%')});
  }
`

export const FilterOption = styled.div<{ $selected?: boolean }>`
  padding: 8px 20px;
  font-size: 14px;
  color: ${({ $selected }) => ($selected ? '#00ade6' : '#1a1a1a')};
  cursor: pointer;
  transition: all 0.15s;
  position: relative;
  font-weight: ${({ $selected }) => ($selected ? 500 : 400)};

  &:hover {
    background: #f8f8f8;
  }

  ${({ $selected }) =>
    $selected &&
    `
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 3px;
      background: #00ade6;
    }
  `}
`

export const PermitsSummary = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #f8f8f8;
  border-radius: 6px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`

export const PermitsCount = styled.div`
  font-size: 14px;
  color: #6b6b6b;

  strong {
    color: #1a1a1a;
    font-weight: 600;
  }
`

export const PermitsList = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
`

export const PermitItem = styled.div<{ $active?: boolean }>`
  padding: 20px 24px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: ${({ $active }) => ($active ? '#e6f7fc' : '#ffffff')};
  border-bottom: 1px solid #e5e5e5;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f8f8f8;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    z-index: 1;
    position: relative;
  }

  @media (max-width: 768px) {
    padding: 20px;
  }
`

export const PermitHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
`

export const PermitInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const PermitIdRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
`

export const PermitId = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
`

export const PermitAddress = styled.div`
  font-size: 14px;
  color: #6b6b6b;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
`

export const PermitType = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 4px;
`

export const PermitDescription = styled.div`
  font-size: 14px;
  color: #6b6b6b;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const PermitDate = styled.div`
  font-size: 12px;
  color: #999999;
  white-space: nowrap;
  flex-shrink: 0;
`

export const PermitBadge = styled.span<{ $category: string }>`
  display: inline-flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing.xs} ${theme.spacing.sm}`};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  transition: ${({ theme }) => theme.transitions.default};

  ${({ $category }) => {
    const colors: Record<string, string> = {
      development: 'rgba(0, 173, 230, 0.1); color: #0099cc',
      renovation: 'rgba(255, 149, 0, 0.1); color: #ff8800',
      transformation: 'rgba(128, 90, 213, 0.1); color: #7b61ff',
      elevation: 'rgba(90, 200, 250, 0.1); color: #00aab8',
      regularisation: 'rgba(255, 59, 48, 0.1); color: #ff3333',
    }
    return `background: ${colors[$category] || colors.development};`
  }}
`

export const LoadMoreContainer = styled.div`
  text-align: center;
  margin-top: 24px;
`

export const LoadMoreBtn = styled.button`
  padding: 8px 24px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover {
    background: #f8f8f8;
    border-color: #999999;
  }
`

export const PermitDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #00ade6;
  font-size: 14px;
  font-weight: 500;
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;

  &:hover {
    gap: 8px;
  }
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 24px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
`

export const EmptyIcon = styled.div`
  width: 48px;
  height: 48px;
  margin: 0 auto 20px;
  color: #999999;
`

export const EmptyTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
`

export const EmptyText = styled.p`
  font-size: 15px;
  color: #6b6b6b;
`
